<template>
    <BaseButton
        :label="buttonLabel"
        icon-class="fa fa-history"
        color="btn-info"
        :is-small="isSmall"
        :hide-label="hideLabel"
        :disabled="disabled"
        v-on="$listeners" />
</template>

<script>
import BaseButton from '@/js/components/common/buttons/BaseButton';

export default {
    name: 'LogButton',

    components: {BaseButton},

    props: {
        label: {type: String, default: null},
        hideLabel: {type: Boolean},
        isSmall: {type: Boolean},
        disabled: {type: Boolean},
    },

    computed: {
        buttonLabel() {
            return this.label || this.$t('common.actions.log');
        },
    },
};
</script>
